import {
  QueryClient,
  QueryFunction,
  QueryFunctionContext,
} from "@tanstack/react-query";
import axiosClient from "./axiosClient";

type UnauthorizedBehavior = "returnNull" | "throw";

export function getQueryFn<T>(options: {
  on401: UnauthorizedBehavior;
}): QueryFunction<T> {
  return async ({ queryKey }: QueryFunctionContext) => {
    try {
      const url = queryKey.map(String).join("/");
      const response = await axiosClient.get<T>(url, { withCredentials: true });
      return response.data;
    } catch (error: any) {
      if (options.on401 === "returnNull" && error?.response?.status === 401) {
        return null as unknown as T;
      }
      throw error;
    }
  };
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: getQueryFn({ on401: "throw" }),
      refetchInterval: false,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 0,
      retry: 1,
      suspense: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export const fetcher = async <T>({
  queryKey,
}: QueryFunctionContext): Promise<T> => {
  const url = queryKey.map(String).join("/");
  const response = await axiosClient.get<T>(url, { withCredentials: true });
  return response.data;
};
